import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import RightTimeApi from "@/API";
import Enums from "@/enums";
import { toast } from "react-toastify";

type DepartmentRow = {
  id: number;
  name: string;
  active?: boolean;
};

type TestTypeDepartmentLink = {
  departmentId: number;
  companyTestTypeId: number;
};

export default function TestTypeDepartmentsTable(props: {
  testType: { id: number; name: string };
  departments?: DepartmentRow[];
  testTypeDepartments?: TestTypeDepartmentLink[];
  adminPerms?: number[];
  refreshLinks: () => Promise<unknown>;
}) {
  const { testType, departments = [], testTypeDepartments = [], adminPerms, refreshLinks } = props;
  const canEdit =
    adminPerms?.includes(Enums.ROLE_PERMS.EditJobs) ||
    adminPerms?.includes(Enums.ROLE_PERMS.EditTestTypes) ||
    adminPerms?.includes(Enums.ROLE_PERMS.CompanyAdmin) ||
    adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin);

  function isAssigned(departmentId: number) {
    return testTypeDepartments.some(
      (link) => link.departmentId === departmentId && link.companyTestTypeId === testType.id
    );
  }

  async function toggleDepartmentAsync(departmentId: number) {
    if (!canEdit) return;
    const resp = await RightTimeApi.putAsync(
      `/CompanyDepartment/${departmentId}/CompanyTestType/${testType.id}/Toggle`,
      {}
    );
    if (resp?.ok) {
      await refreshLinks();
    } else {
      toast.error("Failed to update department assignment for this test type.");
    }
  }

  const sortedDepartments = [...departments].sort((a, b) => {
    const aChecked = isAssigned(a.id);
    const bChecked = isAssigned(b.id);
    if (aChecked !== bChecked) return aChecked ? -1 : 1;
    return a.name.localeCompare(b.name);
  });

  return (
    <div className="tableWrapper factTable horizontal scrollable testTypeDepartmentsTable">
      <table>
        <caption>
          <span className="title">{testType.name} / Departments</span>
        </caption>
        <thead>
          <tr>
            <th>Department</th>
            <th className="toggleColumnHeader">Assigned</th>
          </tr>
        </thead>
        <tbody>
          {sortedDepartments.map((department) => {
            const assigned = isAssigned(department.id);
            return (
              <tr
                key={`ctt-dept-${department.id}`}
                className={department.active === false ? "inactive" : undefined}
              >
                <td className="left">{department.name}</td>
                <td
                  className="actions center"
                  onClick={() => {
                    if (canEdit) toggleDepartmentAsync(department.id);
                  }}
                >
                  {assigned ? (
                    <MdCheckBox className={`checkbox checked actionIcon${canEdit ? "" : " disabled"}`} />
                  ) : (
                    <MdCheckBoxOutlineBlank className={`checkbox unchecked actionIcon${canEdit ? "" : " disabled"}`} />
                  )}
                </td>
              </tr>
            );
          })}
          {sortedDepartments.length === 0 ? (
            <tr>
              <td colSpan={2} className="center">No departments available</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}
